export default __webpack_public_path__ + "static/media/customized-service-vegshelf-wholesale-marketplace.3b072161.png";